import AContainer from '../../library/ExtendedObjects/AContainer.js';
import gameData from '../../gameData.js';
import ABCyaPhaser from '@abcya/abcya_phaser';
import FontKeys from '../../FontKeys.js';

export default class WordBlock extends AContainer {
  constructor(scene, parentCont, config) {
    super(scene);
    this.parentCont = parentCont;
    this.config = config;

    this.createWord();
  }

  createWord() {
    let fSize;
    if (this.parentCont.name === "PortalExport") {
      this.block = this.create(0, 0, "WordTileBlank");

      if (this.config.word.length >= 7 && this.config.word.length < 10) {
        fSize = 20;
        this.block.scaleX = 1.1;
      } else if (this.config.word.length >= 10) {
        fSize = 20;
        this.block.scaleX = 1.3;
      } else {
        fSize = 24;
      }
    } else {
      this.block = this.create(0, 0, "Round2WordTile");

      fSize = 26;
    }

    this.txt = ABCyaPhaser.Text.addText(this.x, this.y - 2, fSize, 0xe2d4bc, FontKeys._Tertre_Med, this.config.word, this).setResolution(1.5).setShadow(1, 1, '#222');

    let width;
    if(gameData.round === 1) width = 110;
    if(gameData.round === 2) width = 150;
    ABCyaPhaser.Text.resizeFontToFitWidth(this.txt, width, 30);

    this.setPosition(this.config.x, this.config.y);
    this.setScale(0, 0);
    this.alpha = 0;

    this.setSize(this.block.width, this.block.height);

    this.on('dragstart', (pointer, gameObject) => {
      this.parentCont.disableWords();
      this.setDepth(4);
      this.scene.killTween(this);
      this.angle = 0;

      this.alpha = 1;
      this.setScale(1, 1);

      this.scene.playSound("word_select");
    });

    this.on('drag', (pointer, dragX, dragY) => {
      this.x = dragX;
      this.y = dragY;
    });

    this.on('dragend', (pointer, gameObject) => {
      let xMin;
      let xMax;
      let yMin;
      let yMax;
      if (gameData.round === 1) {
        xMin = 690;
        xMax = 890;
        yMin = 515;
        yMax = 715;
      } else {
        xMin = this.scene.smallPortal.box.x + this.scene.smallPortal.x - this.scene.smallPortal.box.width / 2;
        xMax = this.scene.smallPortal.box.x + this.scene.smallPortal.x + this.scene.smallPortal.box.width / 2;
        yMin = this.scene.smallPortal.box.y + this.scene.smallPortal.y - this.scene.smallPortal.box.height / 2;
        yMax = this.scene.smallPortal.box.y + this.scene.smallPortal.y + this.scene.smallPortal.box.height / 2;
      }

      if (pointer.x >= xMin && pointer.x <= xMax && pointer.y >= yMin && pointer.y <= yMax) {
        this.analyzeWord(gameObject);
      } else {
        let returnX = this.config.x + this.parentCont.x + this.getRandomX();
        let returnY = this.config.y + this.parentCont.y + this.getRandomY();
        this.scene.addTween(this, 300, { angle: 0, x: returnX, y: returnY }, Phaser.Math.Easing.Back.Out,
          () => {
            this.parentCont.enableWords();
            this.blockIdle();
          }
        );
      }
    });
  }

  analyzeWord() {
    if (gameData.round === 1) {
      this.particleBurst("orange");

      if (this.config.type === "present") {
        this.scene.playSound("round_1_wrong_answer");

        this.scene.smallPortal.flicker();

        this.scene.navBar.turnOnAlarm();

        this.scene.rivette.playAnimation("wrong");

        this.scene.addTween(this, 500, { scaleX: .5, scaleY: .5, alpha: 0 }, Phaser.Math.Easing.None,
          () => { this.returnWord(); });
      } else {
        this.scene.playSound("round_1_correct_answer");

        this.scene.rivette.playAnimation("right");
        this.scene.navBar.updateLevel();

        if (!gameData.gameOver) {
          this.parentCont.clearWord(this);
        }
      }
    }
    else {
      if (this.config.type === gameData.sentences[0].type) {
        this.scene.playSound("round_2_correct_answer");

        this.scene.rivette.playAnimation("right");
        this.scene.navBar.updateLevel();
        this.scene.smallPortal.updateMachine();

        if (this.scene.navBar.alarmPlaying) this.scene.navBar.turnOffAlarm();

        if (!gameData.gameOver) {
          this.parentCont.clearWord();
        }
      } else {
        this.scene.playSound("round_2_wrong_anwswer");

        this.scene.navBar.turnOnAlarm();

        this.scene.rivette.playAnimation("medium");

        let returnX = this.config.x + this.parentCont.x + this.getRandomX();
        let returnY = this.config.y + this.parentCont.y + this.getRandomY();
        this.scene.addTween(this, 1000, { x: returnX, y: returnY, delay: 500 }, Phaser.Math.Easing.Back.InOut,
          () => {
            this.parentCont.enableWords();
            this.blockIdle();
          }
        );
      }
    }
  }

  returnWord() {
    this.scene.addDelay(250, () => { this.particleBurst("orange"); });

    let returnX = this.config.x + this.parentCont.x + this.getRandomX();
    let returnY = this.config.y + this.parentCont.y + this.getRandomY();
    this.scene.addTween(this, 750, { alpha: 1, scaleX: 1, scaleY: 1 }, Phaser.Math.Easing.Bounce.Out,
      () => {
        this.scene.playSound("text_tween");
        this.scene.addTween(this, 1000, { x: returnX, y: returnY, delay: 500 }, Phaser.Math.Easing.Back.InOut,
          () => {
            this.parentCont.enableWords();
            this.blockIdle();
          }
        );
      });
  }

  tweenInBlock(del) {
    this.scene.addDelay(del, () => {
      this.scene.playSound("round_1_questions_appear");
      this.particleBurst("blue");
    });

    this.scene.addTween(this, 1250, { alpha: 1, delay: del }, Phaser.Math.Easing.None);
    this.scene.addTween(this, 1250, { scaleX: 1, scaleY: 1, delay: del }, Phaser.Math.Easing.Back.Out,
      () => { this.blockIdle(); });
  }

  blockIdle() {
    let randAngle = Phaser.Math.Between(-3, 3);
    let randTime = Phaser.Math.Between(2000, 5000);
    let randDelay = Phaser.Math.Between(0, 2000);

    let randX = this.config.x + this.parentCont.x + this.getRandomX();
    let randY = this.config.y + this.parentCont.y + this.getRandomY();
    this.scene.addTween(this, randTime, { angle: randAngle, x: randX, y: randY, yoyo: true, delay: randDelay }, Phaser.Math.Easing.Sine.InOut,
      () => { this.blockIdle() });
  }

  resetWord(color) {
    this.particleBurst(color);

    this.scene.tweens.killTweensOf(this);
    this.scene.addTween(this, 500, { scaleX: 0, scaleY: 0, alpha: 0 }, Phaser.Math.Easing.None,
      () => { this.cleanUp(); });
  }

  clearWord() {
    this.particleBurst("blue");

    this.disableInteractive();

    this.scene.tweens.killTweensOf(this);
    this.scene.addTween(this, 750, { scaleX: 0, scaleY: 0, alpha: 0 }, Phaser.Math.Easing.None,
      () => { this.cleanUp(); });
  }

  particleBurst(particleColor) {
    let randAmount = Phaser.Math.Between(33, 66);
    let colors;
    let ring;
    let ringWide;
    if (particleColor === "blue") {
      colors = ["bluePart", "particleB2", "particleB3"];
      ring = this.scene.addImage(this.x, this.y, "GetItemPulse4", this.scene.particleAtlas);
      ringWide = this.scene.addImage(this.x, this.y, "GetItemPulse1", this.scene.particleAtlas);
    }
    else if (particleColor === "orange") {
      colors = ["orangePart", "particleY2", "particleY3"];
      ring = this.scene.addImage(this.x, this.y, "oRing", this.scene.particleAtlas);
      ringWide = this.scene.addImage(this.x, this.y, "oRing2", this.scene.particleAtlas);
    }
    ring.setScale(0, 0);
    ringWide.setScale(0, 0);

    let emitter = this.scene.add.particles(this.scene.particleAtlas);
    emitter.createEmitter({
      x: this.x,
      y: this.y,
      frame: colors,
      speed: { min: -75, max: 75 },
      alpha: { start: 0, end: 1 },
      scale: { start: Phaser.Math.Between(1, 3), end: 0 },
      blendMode: 'SCREEN',//{'SCREEN' || "ADD" || "MULTIPLY"},
      lifespan: Phaser.Math.Between(750, 1250),
      alpha: { min: 0, max: 1 },
      quantity: randAmount,
      maxParticles: randAmount,
    });
    emitter.setDepth(4);

    this.scene.addTween(ring, 500, { scaleX: 1, scaleY: 1, alpha: 0, delay: 500 }, Phaser.Math.Easing.None,
      () => { ring.destroy(); });
    this.scene.addTween(ringWide, 1000, { scaleX: 1, scaleY: 1, alpha: 0 }, Phaser.Math.Easing.None,
      () => { ringWide.destroy(); });
  }

  getRandomX() {
    let randX;
    if (this.config.row === 0 || this.config.row === 2 || this.config.row === 4) {
      randX = Phaser.Math.Between(-7, 7);
    }
    else if (this.config.row === 1 || this.config.row === 3) {
      if (this.config.col === 0) randX = Phaser.Math.Between(-7, 10);
      else if (this.config.col === 1) randX = Phaser.Math.Between(-10, 10);
      else if (this.config.col === 2) randX = Phaser.Math.Between(-10, 7);
    }

    return randX;
  }

  getRandomY() {
    let randY;
    if (this.config.row === 0) {
      randY = Phaser.Math.Between(-5, 10);
    }
    else if (this.config.row === 1 || this.config.row === 2 || this.config.row === 3) {
      randY = Phaser.Math.Between(10, 10);
    }
    else if (this.config.row === 4) {
      randY = Phaser.Math.Between(-10, 5);
    }

    return randY;
  }

  cleanUp() {
    if (this.parentCont.name === "PortalExport") {
      let currInd = gameData.blockConfig.indexOf(this.config);
      gameData.blockConfig[currInd].word = null;
      gameData.blockConfig[currInd].type = null;
      gameData.blockConfig[currInd].ind = 0;

      let splice = gameData.blockConfig.splice(currInd, 1);
      gameData.blockConfig.splice(6, 0, splice[0]);
    }

    let arrInd = this.parentCont.words.indexOf(this);
    if (arrInd !== -1) this.parentCont.words.splice(arrInd, 1);

    this.config.ind = 0;
  }
}